import fp from 'lodash/fp';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActionResult } from '../../../common';
import { authTokenSelector } from '../../../session';
import addConfiguration, { apiAction as addAttempt } from './add';
import { apiAction as get } from './get';
import { apiAction as updateAttempt } from './update';

const actions = createActions({
  ATTEMPTS: {
    SAVE: (attempt) => ({ attempt })
  }
})

export function* saveQuizAttempt(action) {
  const { attempt } = action.payload;
  const authToken = yield select(authTokenSelector);
  const apiAction = attempt && attempt.id ? 'update' : 'add';

  const apiActions = {
    add: addAttempt,
    update: updateAttempt
  }
  yield put(fp.get(apiAction, apiActions)(authToken, attempt));

  // Always re-fetch the quiz attempts after starting a quiz so we have the correct IDs
  yield apiActionResult(addConfiguration.action.attempts.api.add);
  yield put(get(authToken, attempt.contentId, null));
}

const configuration = {
  name: 'save',
  action: actions,
  sagas: saveQuizAttempt,
  reducers: {

  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/quiz/configurations/attempts/save.js